import axios from 'axios';
import { PRODUCT_INDEXING_ENDPOINT } from '@dynameat/constants';

export const productIndexingListRequest = (pointOfSaleGuid) => axios.get(
  PRODUCT_INDEXING_ENDPOINT(),
  { params: { point_of_sale__guid: pointOfSaleGuid, page_size: 0 } }
);
export const createProductIndexingRequest = (productIndexingData) => axios.post(PRODUCT_INDEXING_ENDPOINT(), productIndexingData);
export const removeProductIndexingRequest = (productIndexingGuid) => axios.delete(PRODUCT_INDEXING_ENDPOINT(productIndexingGuid));
export const editProductIndexingRequest = (productIndexingGuid, productIndexingData) => axios.patch(PRODUCT_INDEXING_ENDPOINT(productIndexingGuid), productIndexingData);
